export default __webpack_public_path__ + "static/media/i360_id.794f3609.csv";